export const TIME_FORMAT = {
  TWELVE: '12 hours',
  TWENTY_FOUR: '24 hours',
};

export const timeDefaultOptions = {
  name: 'Time Widget',
  clockType: 'digital',
  timezone: 'Europe/Stockholm',
  language: 'en',
  textFont: 'Poppins',
  textSize: 12,
  numbersSize: 24,
  format: TIME_FORMAT.TWENTY_FOUR,
  fontColor: '#000000',
  clockColor: '#000000',
  backgroundColor: '#FFFFFF',
  opacity: 100,
};

export const TIME_CLOCK_TYPE = {
  DIGITAL: 'digital',
  ANALOG: 'analog',
};

export const TIMEZONES = [
  { value: 'UTC', label: 'UTC' },
  { value: 'America/New_York', label: 'New York UTC-5' },
  { value: 'America/Los_Angeles', label: 'Los Angeles UTC-8' },
  { value: 'Europe/London', label: 'London UTC+0' },
  { value: 'Europe/Stockholm', label: 'Stockholm UTC+1' },
  { value: 'Europe/Berlin', label: 'Berlin UTC+2' },
  { value: 'Europe/Budapest', label: 'Budapest UTC+2' },
  { value: 'Europe/Kiev', label: 'Kiev UTC+3' },
  { value: 'Europe/Moscow', label: 'Moscow UTC+3' },
  { value: 'Asia/Tokyo', label: 'Tokyo UTC+9' },
  { value: 'Australia/Sydney', label: 'Sydney UTC+10' },
];
